<script setup>
import useCoursePermissions from "@/scripts/Courses/CoursePermissionsTab.js";

const {
  isLoading,
  formModel,
  getPermissionInputClass,
  handleSubmit,
  onTogglePackage,
  onToggleModule,
  onTogglePermission,
  onCreateUpdateTmUser,
} = useCoursePermissions();
</script>

<template>
  <div v-if="isLoading" class="d-flex justify-content-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div v-else>
    <form @submit.prevent="handleSubmit">
      <div v-for="pkg in formModel" :key="pkg.packageName">
        <div class="card w-100">
          <div class="card-header">
            <div class="row">
              <div class="input-group col-4">
                <input
                  type="text"
                  class="form-control"
                  :value="pkg.packageName"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text permission-all"
                    :class="getPermissionInputClass(pkg.active)"
                    @click="onTogglePackage(pkg)"
                  >
                    <i
                      class="fas"
                      :class="pkg.active ? 'fa-toggle-on' : 'fa-toggle-off'"
                    ></i>
                  </span>
                </div>
              </div>
              <button
                v-if="pkg.packageName === 'track'"
                type="button"
                class="btn btn-info ml-2"
                @click="onCreateUpdateTmUser"
              >
                Create/Update TM user
              </button>
            </div>
          </div>
          <div class="card-body">
            <div v-for="(mod, index) in pkg.modules" :key="index" class="col">
              <!-- module -->
              <div class="input-group row col-4 mb-3">
                <input
                  type="text"
                  class="form-control"
                  :value="mod.moduleName"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text permission-all"
                    :class="getPermissionInputClass(mod.active)"
                    @click="onToggleModule(mod)"
                  >
                    <i
                      class="fas"
                      :class="mod.active ? 'fa-toggle-on' : 'fa-toggle-off'"
                    ></i>
                  </span>
                </div>
              </div>
              <!-- permissions -->
              <div class="row ml-3">
                <hr />
                <div
                  v-for="perm in mod.permissions"
                  :key="perm.permissionName"
                  class="input-group col-4 mb-3"
                >
                  <input
                    type="text"
                    class="form-control"
                    :value="perm.permissionName"
                  />
                  <div class="input-group-append">
                    <span
                      class="input-group-text permission-all"
                      :class="getPermissionInputClass(perm.active)"
                      @click="onTogglePermission(perm)"
                    >
                      <i
                        class="fas"
                        :class="perm.active ? 'fa-check' : 'fa-times'"
                      ></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="btn btn-primary mt-3">UPDATE</button>
    </form>
  </div>
</template>
